/*
 * Copyright (c) 2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'

const entity = {}
const config = {
  load: async function () {
    return (await hillo.get('/Datev.php?op=getAllDatevCashAccount', {})).content.filter(it => !it.deletedAt)
  }
}

export default IKDataEntity.ModelFactory(entity, config)
